import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

export type MenuItemAnchorProps = React.HTMLProps<HTMLAnchorElement>;

export default function MenuItemAnchor(props: MenuItemAnchorProps) {
    // @ts-ignore The MUI type definitions do not support the "component" prop
    return <MenuItem {...props} component='a' />;
}
